// extracted by mini-css-extract-plugin
module.exports = {"container":"Content_container__1GQ1X"};